import { FormSection, Input, Label, SectionHeading } from "@simplicity/ui";
import { tryParseJson } from "../../../utils";

const SECRETS_CONFIG: Record<string, { key: string; label: string }[]> = {
  powerschools: [
    { key: "clientId", label: "Client ID" },
    { key: "clientSecret", label: "Client Secret" },
  ],
  skyward: [
    { key: "clientId", label: "Client ID" },
    { key: "clientSecret", label: "Client Secret" },
  ],
  deanslist: [{ key: "apiKey", label: "API Key" }],
  "powerschool-enrollment": [{ key: "apiKey", label: "API Key" }],
  schoolmint: [{ key: "api_token", label: "API Token" }],
  "iready-sftp": [{ key: "password", label: "Password" }],
  "file-drop": [{ key: "password", label: "Password" }],
  dna: [
    { key: "accessKey", label: "Access Key" },
    { key: "accessSecret", label: "Access Secret" },
  ],
};

interface SecretsFormProps {
  connectorType: string;
  secretsText: string;
  setSecretsText: (v: string) => void;
  setSecretsError: (v: string | null) => void;
  clearBanner: () => void;
}

export function SecretsForm({
  connectorType,
  secretsText,
  setSecretsText,
  setSecretsError,
  clearBanner,
}: SecretsFormProps) {
  const fields = SECRETS_CONFIG[connectorType];

  if (!fields) {
    return (
      <div className="mb-4">
        <SectionHeading className="mb-1 block">Secret References</SectionHeading>
        <p className="text-sm text-muted-foreground">
          No secrets required for this connector type.
        </p>
      </div>
    );
  }

  const parsed = tryParseJson(secretsText);
  const current: Record<string, unknown> = parsed.ok
    ? (parsed.value as Record<string, unknown>)
    : {};

  function handleChange(key: string, value: string) {
    const prev = tryParseJson(secretsText);
    const base: Record<string, unknown> = prev.ok ? (prev.value as Record<string, unknown>) : {};
    const updated = { ...base, [key]: value };
    setSecretsText(JSON.stringify(updated, null, 2));
    setSecretsError(null);
    clearBanner();
  }

  return (
    <fieldset className="m-0 border-0 p-0">
      <legend className="sr-only">Secret References</legend>
      <FormSection title="Secret References" className="mb-4">
        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">
            Google Secret Manager references should follow this format:
            &ldquo;gsm:projects/[projectNumber]/secrets/[secretId]&rdquo;. Do not put the actual
            secret value in this field.
          </p>
          {fields.map((f) => (
            <div key={f.key}>
              <Label htmlFor={`secret-${f.key}`} className="form-label">
                {f.label}
              </Label>
              <Input
                id={`secret-${f.key}`}
                type="text"
                className="font-mono"
                value={typeof current[f.key] === "string" ? (current[f.key] as string) : ""}
                onChange={(e) => handleChange(f.key, e.target.value)}
                placeholder="gsm:projects/…/secrets/…"
                autoComplete="one-time-code"
              />
            </div>
          ))}
        </div>
      </FormSection>
    </fieldset>
  );
}
